"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Forms/EditCoworker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');


var _orgMember = require('shared/validation/orgMember');

var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal');

const preventDefault = e => e.preventDefault()








// An org admin's edit of a coworker's name and title (Directory → Coworkers).
const EditCoworkerForm = ({
  defaultValues,
  controlsClassName,
  onSubmit,
  onCancel,
}) => {
  const { register, handleSubmit, formState } = _reacthookform.useForm({
    resolver: _orgMember.coworkerResolver,
    mode: 'onChange',
    defaultValues,
  })
  const { isValid, isDirty, isSubmitting, errors } = formState

  return (
    _react2.default.createElement('form', { onSubmit: preventDefault, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: true,
          title: "First Name" ,
          placeholder: "E.g. John" ,
          inputProps: register('firstName'),
          errorMessage: _optionalChain([errors, 'access', _ => _.firstName, 'optionalAccess', _2 => _2.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          title: "Last Name" ,
          placeholder: "E.g. Parker" ,
          inputProps: register('lastName'),
          errorMessage: _optionalChain([errors, 'access', _3 => _3.lastName, 'optionalAccess', _4 => _4.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        )
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement(_Form.InputSection, {
          title: "Name Suffix" ,
          placeholder: "E.g. MD" ,
          inputProps: register('suffix'),
          isOptional: true,
          errorMessage: _optionalChain([errors, 'access', _5 => _5.suffix, 'optionalAccess', _6 => _6.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          title: "Title",
          placeholder: "E.g. Attending Physician"  ,
          inputProps: register('title'),
          isOptional: true,
          errorMessage: _optionalChain([errors, 'access', _7 => _7.title, 'optionalAccess', _8 => _8.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Save",
        isPrimaryEnabled: isValid && isDirty && !isSubmitting,
        onPrimaryBtnClick: handleSubmit(onSubmit),
        isPrimaryLoading: isSubmitting,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onCancel,
        className: controlsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, EditCoworkerForm)
